import Vue from "vue"
import VueRouter, { RouterOptions, Route } from "vue-router"
import { routers, appRouters, otherRouters } from "./router"
// import { App, } from "./router.vcponlineok"
// import iView from "iview"
import Util from "../lib/util"
import { staffUserRouters } from "./router.staff-user"
import { accountRouters } from "./router.account"
import { AppCivilSuitInfoDto } from "@/asdcom/apiproxy/apiproxy.dto"
// import Cookies from "js-cookie"

Vue.use(VueRouter)

const RouterConfig: RouterOptions = {
  mode: "history",
  routes: routers,
}

export const router = new VueRouter(RouterConfig)

//  router.beforeEach((to: Route, from: Route, next: any) => {
//    abp.log.debug({"router next":to.name});
//    sweetAlert({title:"Router beforeEach", text:`from:${from.name} -> to:${to.name}`}).then(()=>{
//      //next();
//    })

//  });

router.beforeEach((to: Route, from: Route, next: any) => {
  //  abp.log.debug({ "router beforeEach to": to.name })
  Util.title(to.meta.title)

  // if page is marked as public, we just navigate to it.
  // "login" page is our home/dashboard page, so we handle it differently.
  if (to.meta.isPublic !== undefined && to.meta.isPublic && to.name !== "login") {
    next()
  } else if (!!Util.abp.session.userId && to.name === "login") {
    Util.title(to.meta.title)
    if (window.abp.auth.hasPermission("Pages.Tenant.StaffUser")) {
      // abp.log.debug({ "Router next": "Dashboard" })
      next({ name: "Dashboard" })
    } else {
       abp.log.debug({ "Router next": "Login" })
      //sweetAlert({ title: "Unexpected Error", text: "You do not have enough permissions to view Dashboard." })
      // next({ name: "login" })
      next({ name: "error-403" })
    }
  }
  else if (!Util.abp.session.userId && to.name !== "login") {
    next({ name: 'login' });
  } else {
    const curRouterObj = Util.getRouterObjByName([otherRouters, ...appRouters, ...staffUserRouters, ...accountRouters], to.name)
    if (curRouterObj && curRouterObj.permission) {
      if (window.abp.auth.hasPermission(curRouterObj.permission)) {
        Util.toDefaultPage([otherRouters, ...appRouters, ...staffUserRouters, ...accountRouters], to.name, router, next)
      } else {
        abp.log.warn({ "Route not allowed:": {
          "route path":to.fullPath,
          "required permission:":curRouterObj.permission} })
        next({
          replace: true,
          name: "error-403",
        })
      }
    } else {
      Util.toDefaultPage([...routers], to.name, router, next)
    }
  }
})
router.afterEach(to => {
  Util.openNewPage(router.app, to.name, to.params, to.query)
  window.scrollTo(0, 0)
})
